module.exports = "data:image/webp;base64,UklGRuIAAABXRUJQVlA4INYAAACQDgCdASpoAVQAPm02lUmkIqIiIEhIgA2JaW7hbGD5ho+egBP4eyy6o38YA3lWSBOBd8tll6s1vstGuVZHsEF8WZ0T5x7IldfLXSgo0A1Se4qMOyBTu+WulCOQAaw1IedamBKwBm8134pZ2klpqiw+UH1O2DOnTp06dOnIAAD+/hdnZLck9v5YAfCaACIgdnAD5ZMcrhFH3b2Ar/fNQrGm/gIwLdnmXur3WIZmX2lGACSGE3XY7MpXlgKh/dTW2X5nnYg94C5/htyaIAC4bRYP5wwAAAAA"


//////////////////
// WEBPACK FOOTER
// ./src/static/img/head/content-bg.webp
// module id = lOW3
// module chunks = 3